export const adminManagerRegEx = new RegExp(/^(admin|manager)$/);

export const notApprovedStatusRegEx = new RegExp(/^(DRAFT|SUBMITTED|PARTIALLY_APPROVED|PARTIALLY_DECLINED|DECLINED)$/);

export const internalTenantTypeRegEx = new RegExp(/^(sandbox|developer|sales_demo|debug)$/i);

export const CPTIRegEx = new RegExp(/^(client|project|task|item)$/i);

export const clientProjectRegEx = new RegExp(/^(client|project)$/i);

export const departmentLocationRegEx = new RegExp(/^(department|location)$/i);
